// pull in config vars
import * as config from "../config"
import getJamFilledCookie from "../getJamFilledCookie"
// import getUserIdFromJamFilledCookie from "../getUserIdFromJamFilledCookie"
import getUserIdFromLocalStorage from "../getUserIdFromLocalStorage"
import fetch from "isomorphic-fetch"
import percentOffsetFromElement from "../percentOffsetFromElement"
import createUrlPattern from "../createUrlPattern"
import { DeviceDetectorResult } from "device-detector-js"

type Device = DeviceDetectorResult

export default async function createNewThread(
	x: number,
	y: number,
	message: string,
	JAM_ID: string,
	device: Device,
	screenWidth: number,
	screenHeight: number,
	elementSelectorForNewThread: string,
) {
	const systemInfo = {
		browser: {
			name: device.client ? device.client.name : null,
			version: device.client ? device.client.version : null,
		},
		os: {
			name: device.os ? device.os.name : null,
			version: device.os ? device.os.version : null,
		},
		screenDimensions: {
			width: screenWidth,
			height: screenHeight,
		},
	}

	// get percent from top and left of selector element rect to be able to display thread based on that
	// so that element doesn't appear on every page and also sticks to right element on diff window sizes
	// should also get url / path if document.body
	const { percentFromTop, percentFromLeft } = percentOffsetFromElement(
		x,
		y,
		elementSelectorForNewThread,
	)

	const { host, pathPatternArray } = createUrlPattern(
		window.location.host,
		window.location.pathname,
	)

	try {
		const res = await fetch(
			`${config.API_HOSTNAME}/api/plugin/jam/${JAM_ID}/threads`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"jam-filled-cookie": getJamFilledCookie(),
					"jam-filled-userid": getUserIdFromLocalStorage(),
				},
				body: JSON.stringify({
					author: getUserIdFromLocalStorage(),
					x,
					y,
					jamId: JAM_ID,
					firstMessage: message,
					systemInfo,
					selector: elementSelectorForNewThread
						? elementSelectorForNewThread
						: "body",
					percentFromTop,
					percentFromLeft,
					host,
					path: JSON.stringify(pathPatternArray),
					originalUrl: window.location.href,
				}),
			},
		)

		const json = await res.json()

		// returns updated thread object
		return json
	} catch (e) {
		return false
	}
}
